import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  toggle(e) {
    const element = document.querySelector('.header-mobile')
    const links = document.querySelector('.header-nav')
    if (element.classList.contains('header-mobile_open')) {
      element.classList.remove('header-mobile_open')
      links.classList.remove('header-nav_mobile')
    } else {
      element.classList.add('header-mobile_open')
      links.classList.add('header-nav_mobile')
    }
  }

  hideMobile(e) {
    const element = document.querySelector('.header-mobile')
    const links = document.querySelector('.header-nav')
    element.classList.remove('header-mobile_open')
    links.classList.remove('header-nav_mobile')
  }

}